export default __webpack_public_path__ + "static/media/arceaux_vs_pince-roues.e0dc5d62.png";